import React from 'react';
import { addressUtil } from '../../utils/AddressUtils';
import InputBlock from '../connectedForm/InputBlock';
import InputLabel from '../connectedForm/InputLabel';
import InputGroup from '../connectedForm/InputGroup';

export const AddressInfo = ({ address, entityType = 'customer' }) => {
  let addressInfo = `Please select a ${entityType}`;
  if (address) {
    addressInfo = addressUtil(address);
  }

  return (
    <InputBlock>
      <InputLabel />
      <InputGroup>
        <div>{addressInfo}</div>
      </InputGroup>
    </InputBlock>
  );
};
